exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-richtexteditor{position:relative;display:inline-block;height:auto;width:100%}.ba-common-richtexteditor .is-validation{visibility:visible}.ba-common-richtexteditor .validation-error{visibility:hidden;display:block;font-size:.75rem;font-weight:600;margin-top:8px;color:#e62325}.ba-common-richtexteditor{transition:opacity .2s ease-in-out}.ba-common-richtexteditor.is-error .validation-error{visibility:visible}", ""]);

// exports
exports.locals = {
	"richtexteditorClassName": "\"ba-common-richtexteditor\""
};